export enum TemplateReferenceType {
    Commit = 'commit',
    Branch = 'branch',
    Tag = 'tag',
}